'use client';

import { VelocityClient } from '@velocity-exchange/sdk';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftClientIsReady from './useDriftClientIsReady';

const useDriftClient = (): VelocityClient | undefined => {
	const isDriftClientReady = useDriftClientIsReady();
	const driftClient = useDriftStore((s) => s.driftClient?.client);

	return isDriftClientReady ? driftClient : undefined;
};

export default useDriftClient;
